module.exports = __webpack_public_path__ + "static/communcation-based-on-preference-56c2e0e21c5363a440a9261a045cf68f.svg";